import {EasyFlex, FlexItem} from "../../partials/ActionHeader";
import * as React from "react";

export const RegistrationMark = ({children, style, ...props}) => (
	<EasyFlex inline style={{border: "2px solid black", borderRadius: 5, overflow: "hidden", ...style}} {...props}>
		<FlexItem shink={0} style={{width: 10, background: "blue"}}></FlexItem>
		<FlexItem className={"monospace"} grow={100} style={{padding: "1px 8px", fontWeight: "bold", whiteSpace: "nowrap", background: "white", color: "black", fontSize: "larger"}}>{children}</FlexItem>
	</EasyFlex>
);
